import React from 'react';
import { DropdownOptions } from '@Models/types';
interface SelectProps {
  label: string | React.ReactNode;
  value: string | undefined;
  updateField: (value: string) => void;
  options: DropdownOptions[];
}

const Select: React.FC<SelectProps> = ({
  label,
  value,
  updateField,
  options,
}) => {
  return (
    <>
      {/* Model Field */}
      <div className="flex flex-col items-center gap-2 rounded p-2 hover:bg-[#edf7ff] sm:flex-row">
        <label className="flex w-full py-1 sm:w-[220px]">{label}</label>

        <select
          onChange={(e) => updateField(e.target.value)}
          value={value}
          className="flex w-full rounded border border-gray-300 p-2 py-1 font-normal text-gray-600 outline-none"
        >
          {options.map((option, index) => {
            return (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </select>
      </div>
    </>
  );
};

export default Select;
